import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { routes } from '@libs/utils';
import { isMobileOrTablet } from '@libs/ui-lib';

export const MobileGuard: CanActivateFn = (route: ActivatedRouteSnapshot): UrlTree | boolean => {
  const router = inject(Router);
  const platform = inject(Platform);

  const isRegistrationSuccess = route.queryParams['registrationSuccess'];
  const isSiteAdminFlow = route.queryParams['isSiteAdminFlow'];
  const isSetupFlow = route.queryParams['isSetupFlow'];

  if (isMobileOrTablet(platform)) {
    if (isRegistrationSuccess) {
      return router.createUrlTree([routes.getTheApp], { queryParams: { registrationSuccess: true } });
    }
    if (route.url.some((url) => url.path === routes.setup) || isSetupFlow) {
      return router.createUrlTree([routes.getTheApp], { queryParams: { continueOnDesktop: true } });
    }
    if (route.url.some((url) => url.path === routes.siteAdmin) || isSiteAdminFlow) {
      return router.createUrlTree([routes.getTheApp], { queryParams: { siteAdminOnMobile: true } });
    }
    return router.createUrlTree([routes.getTheApp]);
  } else {
    return true;
  }
};
